import { IReactiveModel, ViewModel } from '@descomplica/microfrontend-core';
import { action, makeAutoObservable, observable } from 'mobx';

import type {
  InvitationDto,
  InvitationsSearchCriteria,
  Pagination,
} from '@/shared/application/interfaces/pegasus-io.gateway';

import { GetInvitationsCollaboration } from '../../../application/collaborations/get-invitations.collaboration';

@ViewModel({ singleton: true })
export class InvitationsViewModel implements IReactiveModel {
  @observable invitations: InvitationDto[] = [];
  @observable isLoading = false;
  @observable hasError = false;

  @observable isPaginationLoading = false;
  @observable hasPaginationError = false;

  @observable searchCriteria: InvitationsSearchCriteria = {};
  @observable pagination: Pagination;

  constructor(private getInvitationsCollaboration: GetInvitationsCollaboration) {
    makeAutoObservable(this);

    this.resetPagination();
  }

  @action
  resetPagination() {
    this.pagination = {
      page: 1,
      pageSize: 10,
      totalItems: 0,
    };
  }

  @action
  setPage(page: number): void {
    this.pagination.page = page;
    this.getInvitations();
  }

  @action
  setPageSize(pageSize: number): void {
    this.pagination.pageSize = pageSize;
    this.getInvitations();
  }

  @action
  setSearchCriteria(searchCriteria: InvitationsSearchCriteria) {
    this.searchCriteria = searchCriteria;

    this.resetPagination();
    this.getInvitations();
  }

  @action
  async onInit() {
    try {
      this.isLoading = true;

      const { data: invitations, pagination } = await this.getInvitationsCollaboration.run({
        searchCriteria: this.searchCriteria,
        pagination: this.pagination,
      });

      this.pagination.totalItems = pagination.totalItems;
      this.invitations = invitations;
    } catch (error) {
      console.error(error);
      this.hasError = true;
    } finally {
      this.isLoading = false;
    }
  }

  async getInvitations() {
    try {
      this.isPaginationLoading = true;
      this.hasPaginationError = false;

      const { data: invitations, pagination } = await this.getInvitationsCollaboration.run({
        searchCriteria: this.searchCriteria,
        pagination: this.pagination,
      });

      this.pagination.totalItems = pagination.totalItems;
      this.invitations = invitations;
    } catch (error) {
      console.error(error);
      this.hasPaginationError = true;
    } finally {
      this.isPaginationLoading = false;
    }
  }
}
